import unescapedText from 'I18n/utils/unescapedText';
import { UsageScreenProvider } from 'marketplace-ui-tracking';
import { AllProductsSection } from '../components/AllProductsSection';
import { ContinueBrowsingSection } from '../components/ContinueBrowsingSection';
import { DashboardPageWithHero } from '../components/DashboardPageWithHero';
import { SolutionsPartnersPageHeader } from '../components/headers/SolutionsPartnersPageHeader';
import { StorefrontPageMetadata } from '../components/StorefrontPageMetadata';
import { Screens } from '../constants/usage';
import { useTrackHomepageViewedEvent } from '../hooks/useTrackHomepageViewedEvent';
import { BrowsePopularPartnersSliderSection } from './components/BrowsePopularPartnersSliderSection';
import { RecommendedPartners } from './components/RecommendedPartners';
import { SolutionsStorefrontExplainer } from './components/SolutionsStorefrontExplainer';
import { SuggestedAccreditations } from './components/SuggestedAccreditations';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SolutionsPartnersPage() {
  useTrackHomepageViewedEvent({
    loading: false,
    screen: Screens.SOLUTIONS_PARTNERS,
    type: 'SOLUTIONS_PARTNER_PROFILE'
  });
  return /*#__PURE__*/_jsx(UsageScreenProvider, {
    screen: Screens.SOLUTIONS_PARTNERS,
    children: /*#__PURE__*/_jsxs(DashboardPageWithHero, {
      headerComponent: /*#__PURE__*/_jsx(SolutionsPartnersPageHeader, {}),
      children: [/*#__PURE__*/_jsx(StorefrontPageMetadata, {
        title: unescapedText('marketplaceStorefront.documentHead.solutions.title'),
        metaDescription: unescapedText('marketplaceStorefront.documentHead.solutions.metaDescription')
      }), /*#__PURE__*/_jsx(BrowsePopularPartnersSliderSection, {}), /*#__PURE__*/_jsx(ContinueBrowsingSection, {}), /*#__PURE__*/_jsx(SuggestedAccreditations, {}), /*#__PURE__*/_jsx(RecommendedPartners, {}), /*#__PURE__*/_jsx(AllProductsSection, {
        productType: "SOLUTIONS_PARTNER_PROFILE",
        sectionIndex: 5
      }), /*#__PURE__*/_jsx(SolutionsStorefrontExplainer, {})]
    })
  });
}